// User DP — minimal circle with initial letter. Defaults to "Y" for "You".

export default function UserAvatar({ initial = "Y", size = 40, className = "" }) {
  return (
    <div
      className={
        "relative shrink-0 rounded-full flex items-center justify-center " +
        "bg-white text-neutral-900 font-medium " +
        "shadow-[0_6px_18px_-8px_rgba(0,0,0,0.15)] " +
        className
      }
      style={{
        width: size,
        height: size,
        border: "1px solid #EFDDB2",
        fontSize: Math.max(12, Math.round(size * 0.38)),
      }}
      aria-hidden
    >
      {/* subtle gold hairline inner ring */}
      <span
        aria-hidden
        className="absolute inset-[3px] rounded-full pointer-events-none"
        style={{ border: "0.5px solid rgba(197,160,89,0.35)" }}
      />
      <span className="relative">{initial}</span>
    </div>
  );
}
